export default {
  children: [
    {
      path: ':blurb?',
      name: 'announcement',
      component: () => import(/* webpackChunkName: "announcement" */ '@/views/announcements/Announcement.vue'),
      meta: {
        requiresAuth: true,
        hideSearchFromHeader: false,
        showRightPanel: false,
      },
    },
  ],
};
